interface ContainerColumnProps {
  children: React.ReactNode;
}

const ContainerColumn: React.FC<ContainerColumnProps> = props => {
  return (
    <div className="container">
      <div className="row">
        <div className="col">{props.children}</div>
      </div>
    </div>
  );
};
export default ContainerColumn;
